<template>
  <div class="step-check">
    <p class="title-check">{{ title }}</p>
		<div class="mt-2">
			<div class="note-checkbox pt-3" v-for="(note, index) in listNotes" :key="index">
				<label class="checkbox-custom mt-2">
					<input type="checkbox" :checked="isViewOnly"
                 @input="agreementCheckListChange(note)"
                 :disabled="isViewOnly"
                 :class="status + '-agreement-checklist'">
					<span class="checkmark-new"></span>
				</label>
				<p class="text-note ml-3">{{ note }}</p>
			</div>
		</div>
    <div class="second-list mt-5 position-relative" v-if="status === 'desk_check_in'">
      <div v-if="isViewOnly" class="protected-view"></div>
      <div class="element-options client-signature">
        <div class="title-boat-img title-signature">
          Client signature
          <img src="../../../assets/images/Icon-edit-blue.svg" alt="" @click="clearSignature" />
        </div>
        <div class="signed-signature" v-if="signedSignature">
          <img :src="signedSignature" width="350" />
        </div>
        <div v-else class="signature-element mt-3">
          <VueSignaturePad :options="{ onBegin }" ref="signaturePad" />
        </div>
      </div>
    </div>
    <div class="mt-4 text-right">
      <span v-if="userAuth && status === 'pre_check'" class="signed-by-username" v-text="'Signed By ' + userAuth.first_name"></span>
      <div class="mt-2" v-if="!isViewOnly">
        <button @click="onSave"
                :disabled="!checkoutAgreementPass"
                type="button" class="btn-dialog ok-btn pl-5 pr-5" style="width: auto" v-text="getButtonText()"></button>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
export default {
  name: "StepCheckClient",
  props: {
    title: {
      type: String,
    },
    status: {
      type: String,
    },
    isViewOnly: {
      type: Boolean,
      default: false,
    },
    listNotes: {
      type: Array,
    },
    signedSignature: {
      type: String,
      default: "",
    },
  },
  created() {
    this.userAuth = this.$cookies.get('_user');
  },
  computed: {
    checkoutAgreementPass() {
      return this.checkedAgreements.length === this.listNotes.length;
    },
  },
  data() {
    return {
      userAuth: null,
      checkedAgreements: [],
    };
  },
  methods: {
    reset() {
      $('.' + this.status + '-agreement-checklist').prop('checked', false);
      this.checkedAgreements = [];
      if (this.isViewOnly) {
        $('.' + this.status + '-agreement-checklist').prop('checked', true);
      }
    },
    agreementCheckListChange(note) {
      if (this.checkedAgreements.includes(note)) {
        this.checkedAgreements.splice(this.checkedAgreements.indexOf(note), 1);
      } else {
        this.checkedAgreements.push(note);
      }
    },
    onSave() {
      this.$emit('onSave')
    },
    getButtonText() {
      if (this.status === 'pre_check') {
        return 'Sign'
      } else {
        return 'Save'
      }
    },
    onBegin() {
      this.$refs.signaturePad.resizeCanvas()
    },
    onTouchMove(event){
      event.preventDefault()
      event.stopPropagation();
    },
    clearSignature() {
      this.$refs.signaturePad.clearSignature();
    },
    saveSignature() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      if (!isEmpty) {
        this.clientSignature = data;
      }

      return isEmpty;
    },
  }
};
</script>

<style lang="scss" scoped>
.step-check {
  height: auto;
  width: 100%;
}
.title-check {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  font-size: 22px;
  line-height: 40px;
  color: #1c5169;
}
.note-checkbox {
  display: flex;
	align-items: flex-start;
}
.text-note {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 22px;
  line-height: 30px;
  color: #555e67;
}

// checkbox
.checkbox-custom {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.checkbox-custom input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
	border: none;
}

/* Create a custom checkbox */
.checkmark-new {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #2C94AB;
	border: none !important;
  border-radius: 9px;
}

/* When the checkbox is checked, add a blue background */
.checkbox-custom input:checked ~ .checkmark-new {
  background-color: #2C94AB;
}

/* Show the checkmark when checked */
.checkbox-custom input:checked ~ .checkmark-new:after {
  display: block;
}

/* Style the checkmark/indicator */
.checkbox-custom .checkmark-new:after {
	content: "";
  position: absolute;
  display: none;
  left: 6px;
  top: 2px;
  width: 8px;
  height: 12px;
  border: solid white;
  border-width: 0 2px 2px 0;
  -webkit-transform: rotate(40deg);
  -ms-transform: rotate(40deg);
  transform: rotate(40deg);
}
.client-signature {
  width: 300px;
  background: #c2d8dd;
  height: max-content;
  border-radius: 40px;
  box-sizing: border-box;
  padding: 15px 20px;
}

.title-signature {
  display: flex;
  justify-content: space-between;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  color: #1c5169;
  letter-spacing: 0.04em;
  border-bottom: 1.5px solid #1c5169;
  padding: 5px 0px;
}

.signature-element {
  height: 150px;
  width: 100%;
  background: #e8eff1;
  box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
  border-radius: 30px;
}
.protected-view {
  position: absolute;
  width: 100%;
  height: 100%;
  background: #fff;
  z-index: 9990;
  opacity: 0.4;
}
</style>
